'use client'

import { navigateUrl } from "@/utils/client-request"
import { formatImageURL } from "@/utils/util"
import { getAvatarColor, getInitials } from "@/utils/avatar"
import { usePathname } from "next/navigation"
import { motion } from "framer-motion"

export default function BrandCard({ brand, index = 0 }: { brand: any, index?: number }) {
  const pathname = usePathname()
  const color = getAvatarColor(String(brand?.id || brand?.name || ''))
  const initials = getInitials(brand?.name)

  return (
    <motion.a href={navigateUrl(`/product?brand=${brand.id}`, pathname)} className="group relative rounded-2xl border border-border bg-white p-4 sm:p-5 flex flex-col items-center text-center transition-all hover:shadow-md hover:border-foreground/15 hover:-translate-y-0.5 cursor-pointer" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.05, duration: 0.5, ease: "easeOut" }} viewport={{ once: true }}>
      <div className="mt-1 mb-3">
        {brand?.thumbnail ? (
          <img src={formatImageURL(brand.thumbnail)} alt={brand.name} className="rounded-xl object-cover border border-border" style={{ width: 72, height: 72 }} />
        ) : (
          <div className="rounded-xl grid place-items-center text-white font-bold border border-black/5" style={{ width: 72, height: 72, background: color, fontSize: 26 }}>
            {initials}
          </div>
        )}
      </div>
      <div className="font-semibold text-[14.5px] tracking-[-0.005em] leading-tight line-clamp-1 w-full text-foreground">{brand.name}</div>
      <div className="mt-3 pt-3 border-t border-border w-full text-[11.5px] text-muted-foreground">
        <span className="font-semibold text-foreground tabular-nums">{brand.productCount || 0}</span> бүтээгдэхүүн
      </div>
    </motion.a>
  )
}
